import React from 'react';
import { NavLink } from "react-router-dom";
import compliance from '../assets/docs/FSDH-COMMITMENT-TO-COMPLIANCE.-2ocx.pdf'

export default class Footer extends React.Component {
  render() {
    return (
      <footer>
            <div className="container-fluid">
                <ul className="social-links">
                    <li>
                        <NavLink to="#">
                            <i className="fa fa-facebook" aria-hidden="true"></i>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="#">
                            <i className="fa fa-instagram" aria-hidden="true"></i>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="#">
                            <i className="fa fa-twitter" aria-hidden="true"></i>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="#">
                            <i className="fa fa-whatsapp" aria-hidden="true"></i>
                        </NavLink>
                    </li>
                </ul>
                <hr />
                <ul className="footer-links">
                    <li>
                        <NavLink to="/about">Subsidiaries</NavLink>
                    </li>
                    <li>
                        <NavLink to="/resources/financials">Resources</NavLink>
                    </li>
                    <li>
                        <NavLink to="">Whistle Blowing</NavLink>
                    </li>
                    <li>
                        <NavLink to="/resources/faqs">FAQs</NavLink>
                    </li>
                </ul>
                <hr />
                <ul className="footer-links-2">
                    <li>
                        <NavLink to="">Privacy Policy</NavLink>
                    </li>
                    {/* <li>
                        <NavLink to="">Sitemap</NavLink>
                    </li> */}
                    <li>
                        <NavLink to="/contact">Our Locations</NavLink>
                    </li>
                    <li>
                        <NavLink to="">Compliance</NavLink>
                    </li>
                </ul>
                <hr />
                <p>&copy; 1900 - {new Date().getFullYear()} FSDH Merchant Bank Limited </p>
            </div>
          
      </footer>
    );
  }
}